export default {"src":"/_next/static/media/ABBV.7f5aa4f5.svg","height":18,"width":18};